import gql from 'graphql-tag';
export const registerMutation = gql `
  mutation register($record: RegisterUserRecord!) {
    registerUser(record: $record) {
      email
    }
  }
`;
//# sourceMappingURL=register.js.map